export var IdTooltipsDelay;
(function (IdTooltipsDelay) {
    IdTooltipsDelay[IdTooltipsDelay["standardDelay"] = 500] = "standardDelay";
})(IdTooltipsDelay || (IdTooltipsDelay = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdTooltipsDelay.ts
// module id = 381
// module chunks = 3